document.querySelectorAll('[data-accordion-title]').forEach(item => item.addEventListener('click', function () {
    const parent_el = item.closest('[data-accordion-parent]');
    const panel_el = parent_el.querySelector('[data-accordion-panel]');

    parent_el.classList.toggle("active");

    if (panel_el.style.maxHeight) {
        panel_el.style.maxHeight = null;
    } else {
        panel_el.style.maxHeight = panel_el.scrollHeight + "px";
    }
}));
